import { Ed25519Account, Ed25519PrivateKey } from "@aptos-labs/ts-sdk";
import { useMemo, useSyncExternalStore } from "react";

import { isProduction } from "@/env";
import { readOverrideWallet } from "@/lib/analytics/override-wallet-capture";

// sessionStorage is written once before hydration; nothing to subscribe to.
const noopSubscribe = () => () => undefined;

// Captured into sessionStorage and stripped from the URL before hydration. Disabled in
// production: private keys must never ride in URLs.
export const useOverrideWallet = () => {
  // Server snapshot is null so hydration matches; the client value applies right after.
  const privateKey = useSyncExternalStore(
    noopSubscribe,
    () => readOverrideWallet({ isProduction }),
    () => null,
  );

  return useMemo(() => {
    if (!privateKey) return null;
    try {
      return new Ed25519Account({ privateKey: new Ed25519PrivateKey(privateKey) });
    } catch {
      return null;
    }
  }, [privateKey]);
};
